import { EJsonQueryPriceType } from '@cian/api-models/common/json_query';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setPriceTypeAction } from '../../../../actions/filters';
import { FCoworkingOfferType } from '../../../../utils/category';

/**
 * @start
 * @todo Удалить блок с RS
 * @description Данный функционал появился в задаче CD-93942, будет удалён в задаче CD-97910
 */
import { getCoworkingWorkplacePriceEnabled } from '../../../../utils/getCoworkingWorkplacePriceEnabled';
/**
 * @end
 */

export function useCoworkingOfferTypeChangeEffect(coworkingOfferType: FCoworkingOfferType): void {
  const dispatch = useDispatch<ReturnType<typeof setPriceTypeAction>>();

  useEffect(() => {
    /**
     * @todo Удалить ветвление с RS
     * @description Данный функционал появился в задаче CD-93942, будет удалён в задаче CD-97910
     */
    if (getCoworkingWorkplacePriceEnabled()) {
      dispatch(
        setPriceTypeAction(
          (FCoworkingOfferType.FlexibleOffice & coworkingOfferType) === 0 ? EJsonQueryPriceType.Workplace : undefined,
        ),
      );
    }
  }, [coworkingOfferType, dispatch]);
}
